export default "__VITE_ASSET__qHG4nKUe__"